import type { LibraryFilters } from "@/types/types";

export function normalizeLibraryFilters(libraryFilters: Partial<LibraryFilters>): LibraryFilters {
    return {
        groupValueFilters: libraryFilters.groupValueFilters ?? [],
        sizeFilters: libraryFilters.sizeFilters ?? [],
        languageFilters: libraryFilters.languageFilters ?? [],
        visibleToFilters: libraryFilters.visibleToFilters ?? [],
        qaStatusFilters: libraryFilters.qaStatusFilters,
        qaUserStatusFilters: libraryFilters.qaUserStatusFilters,
        qaCommentedOnByFilters: libraryFilters.qaCommentedOnByFilters,
        publishedStatusFilters: libraryFilters.publishedStatusFilters,
        searchFilters: libraryFilters.searchFilters,
        dedup: libraryFilters.dedup
    };
}
